import type MuxPlayerElement from '@mux/mux-player'
import type { SyntheticEvent } from 'react'

export const applyAspectRatioFromEvent = (container: HTMLElement | null, event: SyntheticEvent | Event): void => {
  if (!container) {
    return
  }
  const target = event.currentTarget
  if (!target || typeof target !== 'object') {
    return
  }
  const videoWidth = 'videoWidth' in target && typeof target.videoWidth === 'number' ? target.videoWidth : undefined
  const videoHeight = 'videoHeight' in target && typeof target.videoHeight === 'number' ? target.videoHeight : undefined
  if (!videoWidth || !videoHeight) {
    return
  }
  container.style.setProperty('--video-aspect-ratio', `${videoWidth} / ${videoHeight}`)
}

export const applyPlaybackRateToMedia = (
  muxPlayer: MuxPlayerElement | null,
  nativeVideo: HTMLVideoElement | null,
  nextPlaybackRate: number
): void => {
  const media = muxPlayer ?? nativeVideo
  if (media) {
    media.playbackRate = nextPlaybackRate
  }
}
